/**
 * VIC Home FAQs
 * ─────────────────────────────────────────────────────────────
 * Rendered on `/` when the visitor has picked Victoria via the
 * state chip. Curator-style copy - we consolidate current facts
 * from official Victorian sources (SRO, VBA, Planning Victoria,
 * Consumer Affairs Victoria, vic.gov.au) and NEVER give legal,
 * financial or tax advice. Every FAQ points at a real page or
 * external source so the reader can go one click deeper.
 *
 * Amounts and threshold numbers deliberately not baked in - they
 * change each budget cycle. Point at the official page instead.
 */
export const VIC_HOME_FAQS = [
  {
    question: 'Is BuildPilot live in Victoria yet?',
    answer:
      "BuildPilot's live builder matching is available across South Australia and Victoria. The Victoria hub, grants explainers and Melbourne council guides are all published - start the matcher now for a shortlist of vetted Victorian builders for your suburb.",
  },
  {
    question: 'What Victorian grants and concessions can first home buyers access?',
    answer:
      'Victoria currently offers the First Home Owner Grant for new builds under the state cap plus the first home buyer stamp duty concession for purchases under the state thresholds. Because both amounts and eligibility conditions change with each Budget, we do not print figures on this site. The current numbers live on the State Revenue Office, and our /vic/grants page walks through them in plain English with a direct link out.',
  },
  {
    question: 'Which Melbourne councils has BuildPilot covered so far?',
    answer:
      "We have published guides for nine Melbourne local government areas so far: Melbourne, Yarra, Port Phillip, Stonnington, Boroondara, Glen Eira, Whitehorse, Bayside and Whittlesea. Each covers the Planning Victoria permit path, the local overlays that trip up new builds (heritage, neighbourhood character, vegetation protection) and the council's contact details. Open the /vic hub to browse them.",
  },
  {
    question: 'Which regulator do I check for a Victorian builder licence?',
    answer:
      'In Victoria the Victorian Building Authority (VBA) is the licensing regulator for builders and building practitioners. You can search the VBA public register by name or licence number free of charge. Consumer Affairs Victoria handles domestic building contracts, deposits and dispute resolution. BuildPilot links out to both from every Victorian editorial page rather than duplicating their registers.',
  },
  {
    question: 'How is building in Victoria different from South Australia?',
    answer:
      'The high-level differences worth knowing before you compare quotes: Victoria uses the VBA (SA uses CBS), domestic building insurance in Victoria kicks in above the state threshold and is issued by a different set of underwriters, planning permits sit with Planning Victoria and the local council, and the residential BAL bushfire rules are administered by CFA (SA uses CFS). None of that changes the shape of a good build brief, but it does change who you ring when a question comes up.',
  },
  {
    question: 'Can I use BuildPilot tools while I plan my Victorian build?',
    answer:
      'Yes. The Cost Tracker, Checklists, Documents, Milestones, Floor Plan tool, Solar Orientation tool and the free Builder Licence Check are all state-agnostic and work for any Australian build. Any tool or guide that is SA-tuned (live H&L pricing, Adelaide suburb research, Adelaide market updates) is labelled on the page so you know what applies to Victoria and what does not.',
  },
];
